export const STATUS_LABELS = {
    paid: { text: "Paid", cls: "text-avx-success border-avx-success/40 bg-avx-success/10" },
    pending: { text: "Pending", cls: "text-avx-blue border-avx-blue/40 bg-avx-blue/10" },
    cancelled: { text: "Cancelled", cls: "text-avx-danger border-avx-danger/40 bg-avx-danger/10" },
    refunded: { text: "Refunded", cls: "text-avx-muted border-avx-muted/40 bg-white/5" },
    published: { text: "Published", cls: "text-avx-success border-avx-success/40 bg-avx-success/10" },
    draft: { text: "Draft", cls: "text-avx-muted border-avx-muted/40 bg-white/5" },
    coming_soon: { text: "Coming soon", cls: "text-avx-info border-avx-info/40 bg-avx-info/10" },
    active: { text: "Active", cls: "text-avx-success border-avx-success/40 bg-avx-success/10" },
    expired: { text: "Expirada", cls: "text-avx-muted border-avx-muted/40 bg-white/5" },
    past_due: { text: "Cobro fallido", cls: "text-avx-danger border-avx-danger/40 bg-avx-danger/10" },
    disabled: { text: "Disabled", cls: "text-avx-danger border-avx-danger/40 bg-avx-danger/10" },
    blocked: { text: "Bloqueada · formateada", cls: "text-avx-danger border-avx-danger/40 bg-avx-danger/10" },
    replaced: { text: "Replaced", cls: "text-avx-muted border-avx-muted/40 bg-white/5" },
    open: { text: "Open", cls: "text-avx-info border-avx-info/40 bg-avx-info/10" },
    in_progress: { text: "In progress", cls: "text-avx-blue border-avx-blue/40 bg-avx-blue/10" },
    closed: { text: "Closed", cls: "text-avx-muted border-avx-muted/40 bg-white/5" },
};

export default function StatusBadge({ status, className = "", testId }) {
    const cfg = STATUS_LABELS[status] || { text: status || "—", cls: "text-avx-muted border-avx-muted/40 bg-white/5" };
    return (
        <span
            data-testid={testId}
            className={`inline-flex items-center px-2 py-0.5 rounded-sm border text-[10px] font-mono uppercase tracking-[0.2em] ${cfg.cls} ${className}`}
        >
            {cfg.text}
        </span>
    );
}
